import { Search, X } from 'lucide-react'
import React from 'react'

interface KnowledgeFilterProps {
  textValue: string
  onClearSearch: () => void;
  onSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  // onStatusChange: (selectedOption: any) => void;
}

const KnowledgeFilter = ({ textValue, onClearSearch, onSearch }: KnowledgeFilterProps) => {
  return (
    <div>
      <div className="!py-2 dark:border-zink-500">
        <form action="#!">
          <div className="grid grid-cols-1 gap-3 sm:gap-5">
            <div className="relative">
              <input
                type="text"
                className="w-full ltr:pl-8 ltr:pr-8 rtl:pr-8 rtl:pl-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200 text-sm sm:text-base py-2 sm:py-2.5"
                placeholder="Search for Knowledge Name or Description"
                autoComplete="off"
                onChange={onSearch}
                value={textValue}
              />
              <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 sm:top-3 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
              {textValue && (
                <X
                  className="inline-block size-4 absolute ltr:right-2.5 rtl:left-2.5 top-2.5 sm:top-3 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600 cursor-pointer hover:text-slate-700 dark:hover:text-zink-100"
                  onClick={onClearSearch}
                />
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export default KnowledgeFilter
